import { Dispatch } from '@reduxjs/toolkit';
import { AppState } from '../store';
import { parseViolationMessages } from './parse-violation-messages';

export type DeleteAccommodationBlockingResult =
  | { status: 'deleted' }
  | { status: 'rejected'; messages: string[] }
  | { status: 'failed' };

export function deleteAccommodationBlocking(id: number, modifiedBy: string): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState): Promise<DeleteAccommodationBlockingResult> => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const response = await fetch(
        // eslint-disable-next-line max-len
        `${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/AccommodationBlocking/${id}?modifiedBy=${encodeURIComponent(
          modifiedBy
        )}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 204) {
        return { status: 'deleted' };
      }

      if (response.status === 400) {
        const messages = await parseViolationMessages(response);
        return { status: 'rejected', messages };
      }

      console.error(`Unexpected response deleting Accommodation Blocking ${id}: ${response.status}`);
      return { status: 'failed' };
    } catch (error) {
      console.error(error);
      return { status: 'failed' };
    }
  };
}
